import React from 'react';

import { IGatsbyImageData } from 'gatsby-plugin-image';
import { ButtonContentfulModel } from '../../api/models/Button';
import { PhoneCarouselContentfulModel } from '../../api/models/PhoneCarousel';
import LinkBranded from '../../elements/links/Link.branded';
import LinkSimple from '../../elements/links/Link.simple';
import Heading from '../../elements/typography/heading';
import {
  CarouselAlignment,
  CarouselBackground,
  CarouselButtonContainer,
} from './phone-carousel-styles';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import PhoneCarouselWrapper from './PhoneCarouselWrapper';

export interface PhoneCarouselProps {
  phoneItems: PhoneCarouselContentfulModel['contentfulchildren'];
  headerText: string;
  actionButtons?: ButtonContentfulModel[]
}

export interface PhoneCarouselPhoneIndex {
  image: { gatsbyImageData: IGatsbyImageData };
  title: string;
  description: string;
  isEdge: boolean;
  isMiddle: boolean;
  isCenter: boolean;
  translatePercentOffset: number;
  index: number;
  phoneIndex: number;
}

const PhoneCarousel = ({ phoneItems, headerText, actionButtons }: PhoneCarouselProps): JSX.Element => {
  return (
    <CarouselBackground>
      <CarouselAlignment>
        <Heading text={headerText} size="3.125em" sizeSm="1.75em" align="center" />
        <PhoneCarouselWrapper phoneItems={phoneItems} />
        {
          actionButtons?.length ?
            <FadeInAnimationWrapper>
              <CarouselButtonContainer>
                {
                  actionButtons.map((button) => {
                    if (button.variant.includes('primary')) {
                      return <LinkBranded url={button.url} key={button.id} text={button.text} caption={button.helpText} justify="center" captionJustify="center" weight="bold" />
                    } else {
                      return <LinkSimple url={button.url} color="main" key={button.id} text={button.text} iconPosition="right" justify="center" icon={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.66 15.8" height="11px"><path d="M18.84,8.26A24.57,24.57,0,0,1,15,5.14,11.73,11.73,0,0,1,13.45,1.6l-2.9.8a15,15,0,0,0,2.17,4.65,11.65,11.65,0,0,0,.93,1H0v3H13.65a11.65,11.65,0,0,0-.93.95,15,15,0,0,0-2.17,4.65l2.9.8A12,12,0,0,1,15,13.86a24.73,24.73,0,0,1,3.82-3.12L20.66,9.5Z" transform="translate(0 -1.6)"></path></svg>} />
                    }
                  })
                }
              </CarouselButtonContainer>
            </FadeInAnimationWrapper>
            : null
        }
      </CarouselAlignment>
    </CarouselBackground>
  );
}

export default PhoneCarousel;
